import React from 'react';

import './index.scss';

const ReturnTop = ({ onClick }) => {
  return (
    <div className="ReturnTop">
      <button className="" type="button" onClick={onClick}>
        <div className="arrow"></div>
      </button>
    </div>
  );
};

export default ReturnTop;